import { styled, spacing, Text, mq, css } from '@thg-commerce/enterprise-theme'
import {
  Separator,
  RadioGroup,
  Button,
  ErrorMessage,
} from '@thg-commerce/gravity-elements'
import { Grid, GridItem } from '@thg-commerce/gravity-system'

export const FormContainer = styled.div`
  padding: ${spacing(4)} ${spacing(2)};
  border-radius: ${spacing(1)};
  border: solid 1px ${(props) => props.theme.colors.palette.greys.grey};
`

export const Title = styled.h2`
  ${Text('large1', 'alternate')};
  margin-bottom: ${spacing(5)};
  color: ${(props) => props.theme.colors.palette.greys.darker};
`

export const SubHeading = styled.h3`
  ${Text('medium1', 'alternate')};
  margin-bottom: ${spacing(1)};
  color: ${(props) => props.theme.colors.palette.greys.darker};
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-around;
`

export const Container = styled.div`
  margin-bottom: ${spacing(5)};
`

export const StyledGrid = styled(Grid)`
  width: 100%;
  margin: 0;
`

export const StyledGridItem = styled(GridItem)`
  margin: 0;
`

export const StyledErrorMessage = styled(ErrorMessage)`
  margin-top: ${spacing(0.5)};
`

export const StyledSeperator = styled(Separator)`
  padding: ${spacing(1)} 0 ${spacing(5)};
`

export const StyledRadioGroup = styled(RadioGroup)`
  margin-bottom: ${spacing(5)};
`

const MediaQueryStyling = css`
  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    width: 50%;
  }

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    width: 40%;
  }
`

export const StyledButton = styled(Button)`
  width: 100%;
  margin-bottom: ${spacing(2)};

  &:hover {
    margin-bottom: ${spacing(2)};
  }

  ${MediaQueryStyling};
`

export const TextContainer = styled.div`
  ${Text('xsmall', 'default')}
  color: ${(props) => props.theme.colors.palette.greys.darker};

  ${MediaQueryStyling};
`
